import React from "react";
import { connect } from "react-redux";
import { compose } from "redux";

import { getSelectedAccountType } from "containers/Accounts/reducer";
import * as setupReducer from "containers/Setup/reducer";
import * as runReducer from "containers/Run/reducer";
import * as loginReducer from "containers/Login/reducer";
import * as deployReducer from "containers/Deploy/reducer";
import * as deploymentsReducer from "containers/Deployments/reducer";
import * as predictReducer from "containers/Predict/reducer";
import * as blueprintReducer from "containers/Blueprint/reducer";
import * as recipeReducer from "containers/Recipe/reducer";
import * as viewReducer from "containers/View/reducer";
import * as globalReducer from "containers/App/reducer";
import * as wizardReducer from "containers/Wizard/reducer";

import AcademicResults from "components/Results/AcademicResults";

class ResultsContainer extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = { deploy: false, step: 0 };

    props.initPredict();
  }

  render() {
    const {
      id,
      model,
      models,
      isDeploy,
      bestModel,
      isError,
      isShow,
      step,
      index,
      fieldSelect,
      originalId,
      blueprintId,
      academicResultsStep,
      updateAcademicResultsStep
    } = this.props;

    return (
      <AcademicResults
        {...this.props}
        step={academicResultsStep || 0}
        updateStep={(step) => updateAcademicResultsStep(step)}
      />
    );
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  initJob: () => dispatch(setupReducer.initJobFromWizard(ownProps.id, ownProps.blueprintId)),
  incrementStep: () => dispatch(wizardReducer.incrementStep(ownProps.id, ownProps.blueprintId, ownProps.index)),

  updateRunPlotType: (type) => dispatch(runReducer.updateRunPlotType(ownProps.id, type)),

  updateIsForceOptimized: (newVal) => dispatch(setupReducer.updateIsForceOptimized(ownProps.id, newVal)),

  updateSelectedMiniBlueprint: (bp) => dispatch(setupReducer.updateSelectedMiniBlueprint(ownProps.id, bp)),
  updateSelectedBlueprintId: (bpId) => dispatch(setupReducer.updateSelectedBlueprintId(ownProps.id, bpId)),
  updateAcademicResultsStep: (step) => dispatch(setupReducer.updateAcademicResultsStep(ownProps.id, step)),

  updateChooseModel: (model) => dispatch(runReducer.updateFeatureSelection(ownProps.id, model, true)),
  updateDeploy: () => dispatch(runReducer.toggleDeploy(ownProps.id)),
  updateShowDeploy: (showDeploy) => dispatch(runReducer.updateShowDeploy(ownProps.id, showDeploy)),
  updateImpact: (impactType, impact) => dispatch(setupReducer.updateImpact(ownProps.id, impactType, impact)),
  resetDefaults: () => dispatch(setupReducer.resetDefaults(ownProps.id)),
  updateFieldSelect: (fieldSelect) => dispatch(runReducer.updateFieldSelect(ownProps.id, fieldSelect)),
  updateValueSelect: (valueSelect) => dispatch(runReducer.updateValueSelect(ownProps.id, valueSelect)),
  updateIsFeatureOpen: (isOpen) => dispatch(loginReducer.updateIsFeatureOpen(isOpen)),
  updateProcessLimit: (processLimit) => dispatch(setupReducer.updateProcessLimit(ownProps.id, processLimit)),
  updateProcessLimitPct: (processLimitPct) =>
    dispatch(setupReducer.updateProcessLimitPct(ownProps.id, processLimitPct)),
  updateIsNextStep: (isNextStep) => dispatch(runReducer.updateIsNextStep(ownProps.id, isNextStep)),

  testPredict: () => dispatch(deployReducer.testPredict(ownProps.id)),

  updateCosts: (costs) => dispatch(setupReducer.updateCosts(ownProps.id, costs)),
  updateConversionGain: (conversionGain) => dispatch(setupReducer.updateConversionGain(ownProps.id, conversionGain)),
  updateConversionCost: (conversionCost) => dispatch(setupReducer.updateConversionCost(ownProps.id, conversionCost)),
  updateConversionMissed: (conversionMissed) =>
    dispatch(setupReducer.updateConversionMissed(ownProps.id, conversionMissed)),
  updateConversionSaved: (conversionSaved) =>
    dispatch(setupReducer.updateConversionSaved(ownProps.id, conversionSaved)),
  setCustomValues: (values) => dispatch(setupReducer.setCustomValues(ownProps.id, values)),
  resetImpacts: () => dispatch(setupReducer.resetImpacts(ownProps.id)),

  updateSetup: (setup) => dispatch(setupReducer.updateSetup(ownProps.id, setup)),

  handleRestfulDeploy: (modelId) => dispatch(deploymentsReducer.handleRestfulDeploy(ownProps.id, modelId)),
  stopDeploy: (deployId) => dispatch(deploymentsReducer.stopDeploy(deployId)),

  initPredict: () => dispatch(predictReducer.init(ownProps.id))
});

const mapStateToProps = (state, ownProps) => {
  const models = runReducer.getTransformedSortedModels(state, ownProps.id);
  const bestModel = models && models.length > 0 ? models[0] : undefined;
  const selModel = runReducer.getSelModel(state, ownProps.id);

  const deployRecipeId = blueprintReducer.getDeployRecipeId(state, setupReducer.getBlueprintId(state, ownProps.id));

  const outcomeType = setupReducer.getOutcomeType(state, ownProps.id);
  const isContinuous = outcomeType === "number" || outcomeType === "numerical";

  // Taken out for performance reasons
  // const { maxImpactImprovement, selectedImpactComparison } = runReducer.getImpactImprovement(state, ownProps.id);

  const maxImpactImprovement = undefined;
  const selectedImpactComparison = undefined;

  return {
    // step: createReducer.getStep(state),
    models: models,
    model: selModel,
    bestModel: bestModel,

    panelMode: runReducer.getPanelMode(state, ownProps.id),

    runPlotType: runReducer.getRunPlotType(state, ownProps.id),

    isForceOptimized: setupReducer.getIsForceOptimized(state, ownProps.id),
    impactImprovement: maxImpactImprovement,
    selectedImpactComparison: selectedImpactComparison,

    fieldSelect: runReducer.getFieldSelect(state, ownProps.id),
    isDeploy: runReducer.getIsDeploy(state, ownProps.id),
    isError: runReducer.getIsError(state, ownProps.id),
    errorMessages: runReducer.getErrors(state, ownProps.id),
    cloudURL: runReducer.getCloudURL(state, ownProps.id),
    showDeploy: runReducer.getShowDeploy(state, ownProps.id),
    labels: setupReducer.getLabels(state, ownProps.id),
    netImpactLabel: setupReducer.getNetImpactLabel(state, ownProps.id),
    isDefaultImpacts: setupReducer.getIsDefaultImpacts(state, ownProps.id),
    selectedDataset: setupReducer.getDatasetFromSetup(state, ownProps.id),
    isContinuous: isContinuous,
    isTwoMinuteRun: setupReducer.getIsTwoMinuteRun(state, ownProps.id),
    isQuickRun: setupReducer.getIsQuickRun(state, ownProps.id),
    fieldNames: setupReducer.getFieldNames(state, ownProps.id),
    processLimit: setupReducer.getProcessLimit(state, ownProps.id),
    targeted: setupReducer.getTargeted(state, ownProps.id),
    setupChanged: setupReducer.getSetupChanged(state, ownProps.id),
    deployment: deploymentsReducer.getDeployment(state, ownProps.id, selModel && selModel.id),
    selectedAccountType: getSelectedAccountType(state),
    relatedJobs: runReducer.getRelatedJobs(state, ownProps.id),
    deployRecipeId: deployRecipeId,
    deployRecipeName: recipeReducer.getRecipeName(state, deployRecipeId),
    isEditBlueprint: blueprintReducer.getIsEditing(state, ownProps.blueprintId),
    isBlueprintsLoading: globalReducer.getIsBlueprintsLoading(state),

    conversionGain: setupReducer.getConversionGain(state, ownProps.id),
    conversionSaved: setupReducer.getConversionSaved(state, ownProps.id),
    conversionCost: setupReducer.getConversionCost(state, ownProps.id),
    conversionCost: setupReducer.getConversionCost(state, ownProps.id),

    trueAction: setupReducer.getTrueAction(state, ownProps.id, true),

    isNextStep: runReducer.getIsNextStep(state, ownProps.id),

    currentState: runReducer.getCurrentStateImpact(state, ownProps.id),

    miniModels: undefined,

    selectedMiniBlueprint: setupReducer.getSelectedMiniBlueprint(state, ownProps.id),
    selBid: setupReducer.getSelectedBlueprintId(state, ownProps.id),
    academicResultsStep: setupReducer.getAcademicResultsStep(state, ownProps.id),

    blueprints: viewReducer.getBlueprints(state)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect)(ResultsContainer);
